import { render, staticRenderFns } from "./job_detail.vue?vue&type=template&id=31e6a2d1&"
import script from "./job_detail.vue?vue&type=script&lang=js&"
export * from "./job_detail.vue?vue&type=script&lang=js&"
import style0 from "./job_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports